import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ComparisonPanel = ({ fields, onClose }) => {
  if (!fields || fields?.length === 0) return null;

  const comparisonCriteria = [
    { key: 'compatibilityScore', label: 'Compatibilité', icon: 'Target', suffix: '%' },
    { key: 'difficulty', label: 'Difficulté', icon: 'TrendingUp', format: (val) => val === 'easy' ? 'Accessible' : val === 'medium' ? 'Intermédiaire' : 'Exigeant' },
    { key: 'marketDemand', label: 'Demande du marché', icon: 'Briefcase', format: (val) => val === 'high' ? 'Forte' : val === 'medium' ? 'Moyenne' : 'Faible' },
    { key: 'salaryRange', label: 'Salaire', icon: 'Coins' },
    { key: 'employmentRate', label: 'Taux d\'emploi', icon: 'Users' },
    { key: 'availableInstitutions', label: 'Établissements', icon: 'School', suffix: ' écoles' }
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-blue-800 text-white p-4 md:p-6 rounded-t-xl flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Icon name="GitCompare" size={28} />
            <div>
              <h2 className="text-xl md:text-2xl font-semibold">Comparaison des filières</h2>
              <p className="text-sm opacity-90">{fields?.length} filières sélectionnées</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 transition-colors flex-shrink-0"
            aria-label="Fermer"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="p-4 md:p-6 lg:p-8">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px]">
              <thead>
                <tr className="border-b-2 border-gray-200">
                  <th className="text-left p-3 text-sm md:text-base font-semibold text-gray-700">Critère</th>
                  {fields?.map((field) => (
                    <th key={field?.id} className="text-left p-3 text-sm md:text-base font-semibold text-gray-800">
                      {field?.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {comparisonCriteria?.map((criterion, index) => (
                  <tr key={criterion?.key} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="p-3">
                      <div className="flex items-center gap-2">
                        <Icon name={criterion?.icon} size={18} color="#6B7280" />
                        <span className="text-sm md:text-base text-gray-700 font-medium">{criterion?.label}</span>
                      </div>
                    </td>
                    {fields?.map((field) => (
                      <td key={field?.id} className="p-3">
                        <span className="text-sm md:text-base text-gray-800">
                          {criterion?.format 
                            ? criterion?.format(field?.[criterion?.key])
                            : `${field?.[criterion?.key]}${criterion?.suffix || ''}`
                          }
                        </span>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-6 bg-blue-50 rounded-lg p-4 md:p-6">
            <h3 className="text-base md:text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
              <Icon name="Lightbulb" size={20} color="#2563EB" />
              Recommandation
            </h3>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              Basé sur votre profil et les critères comparés, nous vous recommandons de considérer en priorité les filières avec le score de compatibilité le plus élevé. N'oubliez pas de prendre en compte vos intérêts personnels, vos capacités académiques et les perspectives d'emploi dans votre région.
            </p>
          </div>

          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <Button
              variant="default"
              iconName="Save"
              iconPosition="left"
              className="flex-1"
            >
              Enregistrer la comparaison
            </Button>
            <Button
              variant="outline"
              iconName="Share2"
              iconPosition="left"
              className="flex-1"
            >
              Partager avec un parent
            </Button>
            <Button
              variant="secondary"
              onClick={onClose}
              className="flex-1"
            >
              Fermer
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonPanel;